import { Navigate, useParams } from 'react-router-dom';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { CustomPageProvider } from './context/custom-page-context';
import { CustomPageComponent } from './custom-page-component';

/** Página customizada do APM, sempre em "/pagina/{slug}". */
export function CustomPageFactory({ legacyArticle = false }: { legacyArticle?: boolean }) {
    return (
        <BaseLayoutFactory>
            <CustomPageProvider>
                <CustomPageComponent legacyArticle={legacyArticle} />
            </CustomPageProvider>
        </BaseLayoutFactory>
    );
}

/**
 * Rota antiga "/pagina-customizada/:slug": id numérico abre o artigo legado;
 * slug redireciona para o endereço atual "/pagina/{slug}" (preservando o prefixo /:state/:city).
 */
export function LegacyCustomPageFactory() {
    const { slug } = useParams();

    if (slug && !/^\d+$/.test(slug)) {
        return <Navigate to={`../pagina/${slug}`} replace />;
    }

    return <CustomPageFactory legacyArticle />;
}
